export enum ButtonStatus {
    FLOAT = 'floating',
    FIXED = 'fixed',
    NONE = 'none'
}
